import { render } from "./GreenButton.vue?vue&type=template&id=647a28e6"
import script from "./GreenButton.vue?vue&type=script&lang=js"
export * from "./GreenButton.vue?vue&type=script&lang=js"

import "./GreenButton.vue?vue&type=style&index=0&id=647a28e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__